function storageKey(userId: number, practiceId: number): string {
  return `portalAiAssistant:lastConversation:${userId}:${practiceId}`
}

function parseStoredId(raw: string | null): number | null {
  if (raw == null || raw === "") return null
  const id = Number.parseInt(raw, 10)
  return Number.isFinite(id) && id > 0 ? id : null
}

export function readLastConversationId(userId: number, practiceId: number): number | null {
  if (typeof window === "undefined") return null
  try {
    return parseStoredId(window.localStorage.getItem(storageKey(userId, practiceId)))
  } catch {
    return null
  }
}

export function writeLastConversationId(userId: number, practiceId: number, id: number | null): void {
  if (typeof window === "undefined") return
  try {
    const key = storageKey(userId, practiceId)
    if (id == null) {
      window.localStorage.removeItem(key)
    } else {
      window.localStorage.setItem(key, String(id))
    }
  } catch {
    // ignore quota / private mode errors
  }
}

export function clearLastConversationId(userId: number, practiceId: number): void {
  writeLastConversationId(userId, practiceId, null)
}
